var toggle = function(e) {
  document.body.classList.toggle('menu-active');
  e.preventDefault();
};

var target = document.querySelector('.toggle-menu');

if (target) {
  target.addEventListener('click', toggle);
}

//

var subToggle = function(e) {
  this.parentNode.classList.toggle('menu__item--active');
  e.preventDefault();
};

var subTargets = document.querySelectorAll('.menu__sub-toggle');

for (var i = 0; i < subTargets.length; i += 1) {
  subTargets[i].addEventListener('click', subToggle);
}

//

var subToggle = function(e) {
  this.parentNode.classList.toggle('nav__item--nine--active');
  e.preventDefault();
};

var subTargets = document.querySelectorAll('.nav__link-toggle');

for (var i = 0; i < subTargets.length; i += 1) {
  subTargets[i].addEventListener('click', subToggle);
}
